import { useContext } from 'react';
import context, { IHighlightContext } from './HighlightContext';

export default function useHighlight(optional = false) {
  const value = useContext(context);
  if (value === undefined) {
    if (optional) return {} as IHighlightContext;
    throw new Error(
      `${useHighlight.name} must be used within a ${context.displayName || 'context'} Provider`,
    );
  }

  return value;
}
